import React from "react"
import { useFilters, usePagination, useSortBy, useTable } from "react-table"
import { useExportData } from "react-table-plugins"
import { Button, Input } from "reactstrap" //CustomInput
import XLSX from "xlsx"
import { DefaultColumnFilter } from "../../../filters/DefaultColumnFilter"
import { Filter } from "../../../filters/Filter"
import "./style.scss"

const TableContainer = ({
  columns,
  data,
  refreshTable,
  sendLockerStatusByEmail,
  accountType,
}) => {
  const uTable = useTable(
    {
      columns,
      data,
      defaultColumn: { Filter: DefaultColumnFilter },
      initialState: { pageIndex: 0, pageSize: 50 },
      getExportFileBlob,
    },
    useFilters,
    useSortBy,
    usePagination,
    useExportData
  )

  let {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
    exportData,
  } = uTable

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " 🔽" : " 🔼") : ""
  }

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value))
  }

  function getExportFileBlob({ columns, data, fileType, fileName }) {
    if (fileType === "xlsx") {
      const header = columns.map((c) => c.exportValue)
      const compatibleData = data.map((row) => {
        const obj = {}
        header.forEach((col, index) => {
          obj[col] = row[index]
        })
        return obj
      })

      let wb = XLSX.utils.book_new()
      let ws1 = XLSX.utils.json_to_sheet(compatibleData, {
        header,
      })
      XLSX.utils.book_append_sheet(wb, ws1, "Inventory")
      XLSX.writeFile(wb, "InventoryExport.xlsx")
      return false
    }
    return false
  }

  return (
    <>
      <div className="list-counter">
        {`נמצאו ${uTable.filteredRows.length} רשומות`}
      </div>
      <button
        className="export-button"
        onClick={() => {
          exportData("xlsx", false)
        }}
      >
        <i class="fa fa-file icon" aria-hidden="true"></i>
        ייצוא לאקסל
      </button>

      <button
        className="export-button"
        onClick={() => sendLockerStatusByEmail()}
      >
        <li className="fa fa-envelope icon" aria-hidden="true"></li>
        שלח סטטוס באמייל
      </button>

      <button
        className="export-button"
        onClick={() => {
          refreshTable()
        }}
      >
        <i class="fa fa-refresh icon" aria-hidden="true"></i>
        רענן טבלה
      </button>

      <div className="table-container">
        <div className="pagination">
          <div md={3}>
            <Button
              color="primary"
              onClick={() => gotoPage(0)}
              disabled={!canPreviousPage}
            >
              {"<<"}
            </Button>
            <Button
              color="primary"
              onClick={previousPage}
              disabled={!canPreviousPage}
            >
              {"<"}
            </Button>
          </div>

          <div md={2} style={{ marginTop: 7 }}>
            דף{" "}
            <strong>
              {" "}
              {pageIndex + 1} מ-{pageOptions.length}{" "}
            </strong>
          </div>

          <div md={3}>
            <Button color="primary" onClick={nextPage} disabled={!canNextPage}>
              {">"}
            </Button>
            <Button
              color="primary"
              onClick={() => gotoPage(pageCount - 1)}
              disabled={!canNextPage}
            >
              {">>"}
            </Button>

            <div md={2}>
              <Input type="select" value={pageSize} onChange={onChangeInSelect}>
                {">"}
                {[50, 100, 150, 200].map((pageSize) => (
                  <option key={pageSize} value={pageSize}>
                    הצג {pageSize}
                  </option>
                ))}
              </Input>
            </div>
          </div>
        </div>
        <table bordered="true" hover="true" {...getTableProps()}>
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <th {...column.getHeaderProps()}>
                    <span {...column.getSortByToggleProps()}>
                      {column.render("Header")}
                    </span>
                    <div>{generateSortingIndicator(column)}</div>
                    <Filter column={column} />
                  </th>
                ))}
              </tr>
            ))}
          </thead>

          <tbody>
            {page.map((row) => {
              prepareRow(row)
              return (
                <tr
                  // onClick={() => onClick(row)}
                  key={row.id}
                >
                  {row.cells.map((cell) => {
                    return (
                      <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                    )
                  })}
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    </>
  )
}

export default TableContainer
